import { MERGE_OFFER_INTO_OTHER_PARAMS } from '../types';

export const mergeOfferIntoOtherParams = (offerData) => ({
    type: MERGE_OFFER_INTO_OTHER_PARAMS,
    payload: offerData,
});
